import React from 'react';
import _ from 'lodash';
import { MODE_AI, MODE_SOLO } from '../HOME/const';
import HumanIcon from './COMPONENTS/HumanIcon';
import RobotIcon from './COMPONENTS/RobotIcon';
import { PN_PURPLE, PN_GREEN, PN_YELLOW, PN_RED, PN_BLUE } from './const';
import { dbget } from '../HOME/utils';

const baseKey = props => {
  let { mode, skill, size } = props;

  if (mode === MODE_AI) {
    mode = `${mode}-${skill}`;
  }

  mode = mode.replace('MODE ', '');

  return `PN • ${mode} • ${size} • `;
};

export const boardKey = props => `${baseKey(props)}BOARD`;

export const statsKey = props => `${baseKey(props)}STATS`;

export const getStats = (props, resolve) => {
  const key = statsKey(props);
  dbget(key, stats => {
    if (!stats) {
      stats = { plays: 0, aggScore: 0, bestScore: 0 };
    }

    resolve(stats);
  });
};

export const isValidPair = (c1, c2, strict) => {
  if (!c1 || !c2) {
    return !strict;
  }

  return (c1.color === c2.color && c1.shape !== c2.shape) || (c1.shape === c2.shape && c1.color !== c2.color);
};

export const sizeInfo = (size, full) => {
  let name, color;

  switch (size) {
    case 1:
      name = full ? 'X-SMALL' : 'XS';
      color = PN_BLUE;
      break;
    case 2:
      name = full ? 'SMALL' : 'S';
      color = PN_GREEN;
      break;
    case 3:
      name = full ? 'MEDIUM' : 'M';
      color = PN_YELLOW;
      break;
    case 4:
      name = full ? 'LARGE' : 'L';
      color = PN_PURPLE;
      break;
    case 5:
      name = full ? 'X-LARGE' : 'XL';
      color = PN_RED;
      break;
    default:
  }

  return { name, color };
};

export const sameOb = (ob1, ob2) => ob1 && ob2 && ob1.id === ob2.id;

export const getNeighbors = ob => [
  { row: ob.row - 1, col: ob.col },
  { row: ob.row, col: ob.col + 1 },
  { row: ob.row + 1, col: ob.col },
  { row: ob.row, col: ob.col - 1 },
];

export const find = (obs, row, col) => {
  const ob = _.find(obs, ob => ob.row === row && ob.col === col);
  return ob;
};

export const scrollTo = ob => {
  if (!ob) {
    return;
  }

  if (inView(ob)) {
    return false;
  }

  const e = document.getElementById(ob.id);

  if (!e) {
    return false;
  }

  e.scrollIntoView({ behavior: 'smooth' });

  return true;
};

export const inView = ob => {
  if (!ob) {
    return;
  }

  const e = document.getElementById(ob.id);

  if (!e) {
    return;
  }

  const r1 = { x1: e.offsetLeft, y1: e.offsetTop };
  r1.x2 = r1.x1 + e.offsetWidth;
  r1.y2 = r1.y1 + e.offsetHeight;

  const s = document.getElementById('surface');
  const r2 = { x1: s.offsetLeft + s.scrollLeft, y1: s.offsetTop + s.scrollTop };
  r2.x2 = r2.x1 + s.offsetWidth;
  r2.y2 = r2.y1 + s.offsetHeight;

  return r1.x1 >= r2.x1 && r1.x2 <= r2.x2 && r1.y1 >= r2.y1 && r1.y2 <= r2.y2;
};

export const maxPairs = (shapeCount, colorCount) => {
  switch (shapeCount * colorCount) {
    case 2:
      return 7;
    case 4:
      return 17;
    case 6:
      return 27;
    case 9:
      return 43;
    case 12:
      return 60;
    case 15:
      return 76;
    case 16:
      return 82;
    case 20:
      return 104;
    default:
      return 0;
  }
};

export const getSoloGrade = (score, plays) => {
  return plays ? _.round(((score || 0) * Math.min(10, plays || 0)) / 10) : 0;
};

export const getDuoGrade = stats => {
  const plays = stats.plays || 0;

  if (!plays) {
    return 0;
  }

  const pairs = stats.avePairs || 0;
  const wins = stats.wins || 0;
  const draws = stats.draws || 0;
  const losses = plays - wins - draws;
  const points = 2 * wins + 1.5 * draws + losses;

  return _.round((pairs * Math.min(10, plays) * (2 * points)) / (3 * plays));
};

export const skillIcon = (props, skill) => {
  if (props.mode === MODE_SOLO) {
    return <HumanIcon width="40px" color={PN_PURPLE} />;
  }

  if (!skill) {
    skill = props.skill;
  }

  switch (skill) {
    case 1:
      return <RobotIcon width="40px" color={PN_GREEN} />;
    case 2:
      return <RobotIcon width="40px" color={PN_YELLOW} />;
    case 3:
      return <RobotIcon width="40px" color={PN_RED} />;
    default:
      break;
  }
};
